import { request } from '@umijs/max';
import { Auth_API } from './api';

export async function API_authEncrypt(options?: { [key: string]: unknown }) {
  return request<CommonModel.ResObjData<AuthModel.EncryptPayload>>(
    Auth_API.AuthEncrypt,
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}

export async function API_authLogin(
  data: AuthModel.LoginParams,
  options?: { [key: string]: unknown },
) {
  return request<CommonModel.ResObjData<AuthModel.UserProfile>>(Auth_API.AuthLogin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

export async function API_authLogout(options?: { [key: string]: unknown }) {
  return request<CommonModel.ResObjData<CommonModel.EmptyData>>(Auth_API.AuthLogout, {
    method: 'POST',
    data: {},
    ...(options || {}),
  });
}

export async function API_userRefreshToken(options?: { [key: string]: unknown }) {
  return request<CommonModel.ResObjData<CommonModel.EmptyData>>(
    Auth_API.UserRefreshToken,
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}

export async function API_userModifyPassword(
  data: AuthModel.ModifyPasswordParams,
  options?: { [key: string]: unknown },
) {
  return request<CommonModel.ResObjData<AuthModel.UserProfile>>(
    Auth_API.UserModifyPassword,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      ...(options || {}),
    },
  );
}

export async function API_roleQueryAll(options?: { [key: string]: unknown }) {
  return request<CommonModel.ResObjData<AuthModel.RoleItem[]>>(
    Auth_API.RoleQueryAll,
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}
